import React from 'react';
import { Field } from 'formik';
import { TextField, CheckboxWithLabel } from 'formik-material-ui'; // import { Debug } from './Debug';

import { Grid, FormControlLabel, makeStyles } from '../../..';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'wrap'
    },
    repeat: {
      margin: 0
    }
  };
});

var TaskName = function TaskName(_ref) {
  var mode = _ref.mode;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "name",
    fullWidth: true,
    label: "Task Name",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === 'view'
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.repeat,
    control: /*#__PURE__*/React.createElement(Field, {
      label: "Section heading",
      name: "heading",
      component: CheckboxWithLabel,
      color: "primary",
      disabled: mode === 'view'
    }),
    label: "Section heading"
  })));
};

TaskName.defaultProps = {
  mode: 'add'
};
export { TaskName };